module.exports = __webpack_public_path__ + "a4a0380405d2330cbcc0a89a2a7b8ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/clubhouse2.png
// module id = 1083
// module chunks = 0